import { useState } from 'react';

function useShowMore() {
  const [showAll, setShowAll] = useState<boolean>(false);

  const onShowMoreClick = () => {
    setShowAll((prevState) => !prevState);
  };

  const showMoreButtonText = showAll ? 'View Less' : 'View More';

  return {
    showAll,
    onShowMoreClick,
    showMoreButtonText,
  };
}

export default useShowMore;
